import { Button } from "@/components/elements/Button";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type TResetPasswordCompletePageProps = {};

export const ResetPasswordCompletePage: FC<TResetPasswordCompletePageProps> = () => {
  const navigate = useNavigate();

  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワード再発行完了</Typography>
      <Typography variant="body14" width={400} color={"#5A6063"}>
        パスワードの再発行が完了いたしました。
        <br />
        パスワードの再発行完了メールをご登録されているメールアド
        <br />
        レス宛に送信いたしました。
      </Typography>
      <Button type="submit" variant="primary" fullWidth onClick={() => navigate(AppRoutes.login)}>
        ログイン画面へ
      </Button>
    </Stack>
  );
};
